export default __webpack_public_path__ + "static/babartronic-87d4365475c4b1dd0acd680e69b7c894.jpg";